module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": 'lg'
    }
  }, [_c('header', {
    staticClass: "border-b px-7 py-4 flex items-center text-xl font-semibold"
  }, [(_vm.selected_tab === 'personal_info') ? _c('span', [_vm._v("Personal Info ")]) : (_vm.selected_tab === 'subjects') ? _c('span', [_vm._v("Subjects Taught")]) : _c('span', [_vm._v("Grades")])]), _vm._v(" "), _c('body', {
    staticClass: "px-7 pt-4 mb-16 flex-grow h-full overflow-auto"
  }, [(_vm.selected_tab === 'personal_info') ? _c('div', [_c('div', {
    staticClass: "bg-gray-100 px-5 rounded py-3 mt-2 flex items-center text-gray-500"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-lg mr-4"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "font-semibold"
  }, [_vm._v("\n            Hi " + _vm._s(_vm.getProfile.name) + ". Welcome to Parlay!\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }, [_vm._v("\n            Let’s start your profile, share a little more about yourself and\n            select subjects and grades you teach.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-6 grid grid-cols-1 sm:grid-cols-2 gap-0"
  }, [_c('div', {
    staticClass: "sm:mr-2.5"
  }, [_c('p', [_vm._v("Avatar")]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-1 items-center"
  }, [_c('img', {
    staticClass: "h-24 w-24 object-cover bg-center rounded-full",
    attrs: {
      "src": _vm.getProfile.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_c('button', {
    staticClass: "px-4 py-2 bg-input rounded cursor-pointer text-gray-500",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openPopupChooseAvatar.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Change Avatar\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 text-gray-500 text-xs"
  }, [_vm._v("\n                Allowed types: jpeg, png, gif\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "text-gray-500 text-xs"
  }, [_vm._v("Size limit: 2MB")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 sm:mt-16 sm:ml-2.5"
  }, [_c('div', [_vm._v("\n            Universe Profile URL\n            "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: ({
        content: _vm.tooltip_content,
        placement: 'top',
        classes: ['universe-profile-url'],
      }),
      expression: "{\n                content: tooltip_content,\n                placement: 'top',\n                classes: ['universe-profile-url'],\n              }"
    }],
    staticClass: "fas fa-question-circle text-gray-300 hover:text-primary universe",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "flex items-center rounded rounded-r-none outline-none px-2 text-sm bg-gray-200 text-gray-500 cursor-default"
  }, [_vm._v("\n              universe.parlayideas.com/profiles/\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile_url),
      expression: "profile_url"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none pl-1 pr-4 py-2 w-full rounded rounded-l-none placeholder-gray-300",
    attrs: {
      "placeholder": 'Profile URL',
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile_url)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.profile_url = $event.target.value
      }, function($event) {
        return _vm.checkProfileUrlExistence(_vm.profile_url)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-red-500 text-xs"
  }, [_vm._v("\n            " + _vm._s(_vm.profileUrlTaken ? 'Profile URL already taken.' : '') + "\n            " + _vm._s(_vm.profileInvalidChars ?
    'Only lowercase letters, numbers and dashes are allowed.' :
    '') + "\n            " + _vm._s(_vm.profileUrlCannotBeEmpty ?
    'Profile URL cannot be empty and must be between 3 and 99 characters' :
    '') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "sm:mr-2.5"
  }, [_c('p', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "placeholder": 'Name',
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, function($event) {
        return _vm.checkName(_vm.name)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-red-500 text-xs mt-1"
  }, [_vm._v("\n            " + _vm._s(_vm.nameIsRequired ? 'Your name is required' : '') + "\n            " + _vm._s(_vm.nameValidation ?
    'Your name must be between 2 and 99 characters' :
    '') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "sm:ml-2.5"
  }, [_c('p', [_vm._v("\n            Preferred Name\n            "), _c('span', {
    staticClass: "text-xs"
  }, [_vm._v("(what your students will see)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preferred_name),
      expression: "preferred_name"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded placeholder-gray-300",
    attrs: {
      "placeholder": 'Preferred Name',
      "type": "text"
    },
    domProps: {
      "value": (_vm.preferred_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.preferred_name = $event.target.value
      }, function($event) {
        return _vm.checkPreferredName(_vm.preferred_name)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-red-500 italic text-xs"
  }, [_vm._v("\n            " + _vm._s(_vm.preferredNameValidation ?
    'Your preferred name must be between 2 and 99 characters' :
    '') + "\n          ")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v("About")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "bg-input focus-within:border-primary border border-solid border-input text-sm text-gray-500 flex-grow outline-none px-4 py-3 w-full rounded placeholder-gray-300 h-28 resize-none",
    attrs: {
      "placeholder": 'Tell us a little bit about yourself',
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]) : (_vm.selected_tab === 'subjects') ? _c('div', [_c('div', {
    staticClass: "bg-gray-100 px-5 flex items-center rounded py-3.5 mt-2 text-gray-500"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-lg mr-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-sm"
  }, [_c('p', [_vm._v("\n            Select the "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("subjects/topics")]), _vm._v(" you\n            teach.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }, [_vm._v("\n            We will use this information to make relevant RoundTable and\n            instructional content recommendations.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-6 grid grid-cols-2 md:grid-cols-3 gap-3"
  }, _vm._l((_vm.subjects), function(subject) {
    return _c('div', {
      key: subject.id
    }, [_c('button', {
      staticClass: "px-4 py-2 w-full flex items-center rounded border border-solid cursor-pointer text-sm",
      class: _vm.selectedSubjects.find(function (s) { return s === subject.id; }) ?
        ['bg-primary border-primary text-white'] :
        ['bg-white border-gray-400 text-gray-500'],
      on: {
        "click": function($event) {
          return _vm.selectUnselectSubjects(subject.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])])
  }), 0)]) : _c('div', [_c('div', {
    staticClass: "bg-gray-100 flex items-center px-5 py-3.5 mt-2 text-gray-500"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-lg mr-4"
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n            Select the "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("grades")]), _vm._v(" you teach.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }, [_vm._v("\n            We will use this "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("information")]), _vm._v(" to\n            make relevant RoundTable and instructional\n            "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("content recommendations.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-6 grid grid-cols-2 md:grid-cols-3 gap-3"
  }, _vm._l((_vm.gradeLevels), function(gr) {
    return _c('div', {
      key: gr.id
    }, [_c('button', {
      staticClass: "px-4 py-2 w-full flex items-center rounded border border-solid cursor-pointer text-sm",
      class: _vm.selectedGradeLevels.find(function (g) { return g === gr.id; }) ?
        ['bg-primary border-primary text-white'] :
        ['bg-white border-gray-400 text-gray-500'],
      on: {
        "click": function($event) {
          return _vm.selectUnselectGrades(gr.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(gr.grade) + "\n          ")])])
  }), 0)])]), _vm._v(" "), _c('footer', {
    staticClass: "px-7 py-4 absolute inset-x-0 bottom-0"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_c('i', {
    staticClass: "fas fa-circle cursor-pointer",
    class: _vm.selected_tab === 'personal_info' ?
      ['text-gray-500'] :
      ['text-gray-300'],
    on: {
      "click": function($event) {
        _vm.selected_tab = 'personal_info'
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-circle cursor-pointer",
    class: _vm.selected_tab === 'subjects' ?
      ['text-gray-500'] :
      ['text-gray-300'],
    on: {
      "click": function($event) {
        _vm.selected_tab = 'subjects'
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-circle cursor-pointer",
    class: _vm.selected_tab === 'grades' ? ['text-gray-500'] : ['text-gray-300'],
    on: {
      "click": function($event) {
        _vm.selected_tab = 'grades'
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center text-sm"
  }, [(_vm.selected_tab === 'subjects' || _vm.selected_tab === 'grades') ? _c('button', {
    staticClass: "px-8 py-2 bg-gray-100 rounded cursor-pointer text-gray-500 font-semibold mr-2.5",
    on: {
      "click": _vm.goToBackTab
    }
  }, [_vm._v("\n          Back\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.selected_tab === 'personal_info' || _vm.selected_tab === 'subjects'
  ) ? _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.profileUrlTaken ||
        _vm.profileInvalidChars ||
        _vm.profileUrlCannotBeEmpty ||
        (_vm.selected_tab === 'subjects' && !_vm.selectedSubjects.length)
    },
    on: {
      "click": _vm.goToNextTab
    }
  }, [_vm._v("\n          Next\n        ")]) : _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.disabledButton
    },
    on: {
      "click": function($event) {
        return _vm.createFirstCourse_updateProfile()
      }
    }
  }, [(_vm.isCreating) ? _c('div', {
    staticClass: "loader"
  }) : _c('div', [_vm._v("Done")])])])])]), _vm._v(" "), (_vm.show_choose_avatar_modal) ? _c('choose-avatar', {
    on: {
      "close": function($event) {
        _vm.show_choose_avatar_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-83f0dd68!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/dashboard/welcomeModal.vue
// module id = 1881
// module chunks = 61